import { timezones } from '@va/assets';
import { Clock } from '@va/icons';
import { IconWithBackground, SelectDropdown } from '@va/ui/design-system';

import { getProviderName, getSupportCenterDomain } from '@va/dashboard/selectors/customization';
import { SettingsHeading } from '@va/dashboard/ui/pages';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { isWixApp } from '@va/util/helpers';
import { useSelector } from 'react-redux';
import useTimezoneCard from './useTimezoneCard';

export const TimezoneCard = () => {
  const translate = useTranslate();
  const isContributor = useSelector(contributorRole);
  const providerName = useSelector(getProviderName);
  const supportCenterDomain = useSelector(getSupportCenterDomain);

  const { onChange, selectedTimezone } = useTimezoneCard();

  return (
    <div className='flex flex-col gap-18px'>
      <SettingsHeading
        title={translate('card.timezone.title')}
        subText={translate('card.timezone.subtitle')}
        tooltip={
          <div className='flex flex-col'>
            <div className='mb-1'>
              {translate(`card.location.tooltip`, {
                providerName,
              })}
            </div>
            {!isWixApp() && <div>{translate('card.location.note.tooltip', { supportCenterDomain })} </div>}
          </div>
        }
      />
      <SelectDropdown
        size='medium'
        disabled={isContributor}
        disabledTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
        onChange={onChange}
        icon={
          <IconWithBackground className='bg-white' icon={() => <Clock strokeColor='#696969' className='w-4 h-4' />} />
        }
        label={translate('card.location.title')}
        selectedOption={selectedTimezone}
        dropdownOptions={timezones}
      />
    </div>
  );
};
